<template>
    <div class="configuration-container shadow-sm" v-if="map">
        <h5 class="first-header">{{ $t("admin.map_configuration.status_header") }}</h5>
        <div class="field">
            <SwitchControl class="switch" v-model="map.statusAvailableOnMap" />
            <span>{{ $t("admin.map_configuration.status_available_in_ondago_app") }}</span>
        </div>
        <div class="field">
            <SwitchControl class="switch" v-model="map.statusVisibleByDefault" />
            <span>{{ $t("admin.map_configuration.status_visible_by_default") }}</span>
        </div>
        <h5>{{ $t("admin.map_configuration.search_tool_header") }}</h5>
        <div class="field">
            <SwitchControl class="switch" v-model="map.openMapObjectListByDefault" />
            <span>{{ $t("admin.map_configuration.open_search_tool_by_default") }}</span>
        </div>
        <div class="field normal-field">
            <label for="sort_method_select" class="form-label">{{ $t("admin.map_configuration.search_tool_sort_order") }}</label>
            <select id="sort_method_select" class="form-control form-select" v-model="map.sortMethod">
                <option disabled value="">{{ $t("admin.map_configuration.search_tool_sort_please_select_one") }}</option>
                <option value="no_sort">{{ $t("admin.map_configuration.search_tool_sort_no_sort") }}</option>
                <option value="alphabetically">{{ $t("admin.map_configuration.search_tool_sort_alphabetically") }}</option>
                <option value="distance">{{ $t("admin.map_configuration.search_tool_sort_by_distance") }}</option>
            </select>
        </div>
        <h5>{{ $t("admin.map_configuration.language_availability") }}</h5>
        <div class="field">
            <SwitchControl class="switch" v-model="map.languageAvailability.english" />
            <span>{{ $t("admin.map_configuration.language_availability_english") }}</span>
        </div>
        <div class="field">
            <SwitchControl class="switch" v-model="map.languageAvailability.french" />
            <span>{{ $t("admin.map_configuration.language_availability_french") }}</span>
        </div>
        <!--<h5>{{ $t("admin.map_configuration.other_parameters_header") }}</h5>
        <div class="field">
            <SwitchControl class="switch" v-model="map.showCalculatedDistance" />
            <span>{{ $t("admin.map_configuration.show_as_crow_flies_distance") }}</span>
        </div>-->
    </div>
</template>

<script>
import SwitchControl from '@/components/ui/control/SwitchControl';
import MapService from '@/service/MapService';

export default {
    components: {
        SwitchControl
    },

    props: {
        publisherId: String,
        mapId: String
    },

    data() {
        return {
            map: null,
            mapService: new MapService(),
        }
    },

    watch: {
        map: {
            handler() {
                this.saveMap();
            },
            deep: true
        }
    },

    methods: {
        loadMap() {
            if (this.publisherId && this.mapId) {
                this.mapService.loadMapForPublisher(this.publisherId, this.mapId).then((map) => {
                    if (!map.languageAvailability) {
                        map.languageAvailability = {
                            english: true,
                            french: true
                        }
                    }
                    if (!map.sortMethod) {
                        map.sortMethod = "alphabetically";
                    }
                    this.map = map;
                }).catch((error) => {
                    console.log(error);
                });
            }
        },

        saveMap() {
            this.mapService.saveMapForPublisher(this.publisherId, this.map).then(() => {
                // TODO: Give feedback to the user
            }).catch((error) => {
                console.log(error);
            });
        }
    },

    mounted() {
        this.loadMap();
    }
}
</script>

<style scoped>
.configuration-container {
    background-color: #ffffff;
    margin: 0 auto;
    padding: 24px;
    text-align: left;
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;
    overflow: scroll;
}

.configuration-container h5 {
    margin-top: 24px;
}

.configuration-container .first-header {
    margin-top: 0px;
}

.switch {
    display: inline-block;
}

.field {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
}

.normal-field {
    display: block;
    max-width: 500px;
}

.field span {
    display: inline-block;
    margin-left: 8px;
    height: 100%;
}

.toolbar {
    margin-top: 24px;
}

.toolbar button {
    margin-right: 16px;
}

</style>